import ClientLogo from './ClientLogo';

export * from './types';

export default ClientLogo;
